import FJConfig from '../../../../config/FJConfig';
import FJPoolStore from '../../../../store/FJPoolStore';
import FJWorkerPool from '../../../../store/FJWorkerPool';
import FJUtil from '../../../../util/FJUtil';
const MAX_MASK_CANVAS_WIDTH = 500;
const MAX_MASK_CANVAS_HEIGHT = 500;

class FJAiMaskCanvas {
    _canvas = null;
    _ctx = null;

    _hoverInCanvas = null;
    _hoverInCtx = null;

    _excessiveCanvas = null;
    _excessiveCtx = null;

    _pointCanvas = null;
    _pointCtx = null;

    _loaded = false;
    _aiMaskId = null;
    _active = true;

    _addPointImage = null;
    _removePointImage = null;
    _selectedPointImage = null;

    _isMobile = false;
    _borderCanvas = null;
    _borderCtx = null;

    // maskCanvas 尺寸
    _maskCanvasSize = {
        width: 0,
        height: 0,
    };

    _pointSize = 28;

    // 快速选择画布列表
    _maskCanvasList = [];

    // 用来判断是否显示mask
    _maskCanvasHasSelectData = [];
    constructor() {
        this._canvas = FJPoolStore.getCanvas(undefined, true);
        this._ctx = this._canvas.getContext('2d');

        this._hoverInCanvas = FJPoolStore.getCanvas(undefined, true);
        this._hoverInCtx = this._hoverInCanvas.getContext('2d');

        this._excessiveCanvas = FJPoolStore.getCanvas(undefined, true);
        this._excessiveCtx = this._excessiveCanvas.getContext('2d');

        this._pointCanvas = FJPoolStore.getCanvas(undefined, true);
        this._pointCtx = this._pointCanvas.getContext('2d');

        this._borderCanvas = FJPoolStore.getCanvas(undefined, true);
        this._borderCtx = this._borderCanvas.getContext('2d');
    }

    /**
     * @desc 初始化颜色画布
     * @param {Object} size
     */
    _initColorCanvas(size) {
        this._excessiveCtx.width = size.width;
        this._excessiveCtx.height = size.height;

        this._excessiveCtx.save();
        this._excessiveCtx.fillStyle = 'rgb(0, 0, 255)';
        this._excessiveCtx.fillRect(0, 0, size.width, size.height);
        this._excessiveCtx.restore();
    }
    /**
     * @desc 获取图片尺寸
     * @param {number} maxSize 最大尺寸
     * @returns
     */
    _getSize(maxSize, size) {
        if (maxSize && (size.width > maxSize || size.height > maxSize)) {
            // 图片过大 压缩处理
            if (size.width > maxSize && size.height > maxSize) {
                if (size.width > size.height) {
                    size.height = Math.round((size.height / size.width) * maxSize);
                    size.width = maxSize;
                } else {
                    size.width = Math.round((size.width / size.height) * maxSize);
                    size.height = maxSize;
                }
            } else if (size.width > maxSize) {
                size.height = Math.round((size.height / size.width) * maxSize);
                size.width = maxSize;
            } else if (size.height > maxSize) {
                size.width = Math.round((size.width / size.height) * maxSize);
                size.height = maxSize;
            }
        }

        return size;
    }
    /**
     * @desc 初始化ai mask画布
     * @param {Object} size
     * @param {Array} aiMaskData
     */
    async init(size, aiMaskData = [], aiMaskId = null, maskDrawSize, realCanvasRatio, isMobile = FJUtil.isMobile()) {
        if (aiMaskId === this._aiMaskId || !size || !size.width || !size.height) return;
        this.clearCanvasList();

        this._canvas.width = size.width;
        this._canvas.height = size.height;
        const borderSize = this._getSize(1000, JSON.parse(JSON.stringify(size)));
        this._borderCanvas.width = borderSize.width;
        this._borderCanvas.height = borderSize.height;
        this._hoverInCanvas.width = size.width;
        this._hoverInCanvas.height = size.height;
        this._pointCanvas.width = size.width;
        this._pointCanvas.height = size.height;
        this._initColorCanvas(size);
        this._isMobile = isMobile;
        this._pointSize = (size.width / maskDrawSize.width) * 16 * realCanvasRatio;
        this._loaded = false;
        this._aiMaskId = aiMaskId;

        const maskSize = this._getMaskCanvasSize(size.width, size.height);

        const maskCanvasHasSelectDataList = [];
        maskCanvasHasSelectDataList.length = aiMaskData.length;
        const maskCanvasList = [];
        maskCanvasList.length = aiMaskData.length;

        console.time('maskCanvasGeneration');
        const that = this;

        const __handleMaskData = data => {
            const { imageBitmap, maskCanvasHasSelectData, maskIndex, svgPath } = data;
            const { predicted_iou } = aiMaskData[maskIndex];

            maskCanvasList[maskIndex] = {
                canvas: imageBitmap,
                predicted_iou,
                isSelected: false,
                isHoverIn: false,
                svgPath,
            };

            maskCanvasHasSelectData.forEach((item, index) => {
                const list = that._maskCanvasHasSelectData[index] || [];
                list.push(maskIndex);
                that._maskCanvasHasSelectData[index] = list;
            });
        };
        await new Promise(resolve => {
            const workerPool = new FJWorkerPool(
                FJConfig.decodeMaskDataWorkPath + '?' + FJConfig.workVersion,
                __handleMaskData,
                resolve,
            );
            for (let i = 0; i < aiMaskData.length; i++) {
                const { segmentation } = aiMaskData[i];

                if (i === 0) {
                    this._maskCanvasSize = {
                        width: segmentation.size[1],
                        height: segmentation.size[0],
                    };
                    this._maskCanvasHasSelectData = [];
                    this._maskCanvasHasSelectData.length = this._maskCanvasSize.width * this._maskCanvasSize.height;
                }
                workerPool.addTask({ maskData: segmentation, maskIndex: i, maskSize, isMobile });
            }
        });

        console.timeEnd('maskCanvasGeneration');

        this._maskCanvasList = maskCanvasList;
        this._updateMaskBorderCanvas();
        this._loaded = true;
        await this._initPointImage();
    }
    /**
     * @desc 更新mask边框画布
     */
    _updateMaskBorderCanvas() {
        if (!this._isMobile) return;
        let svgPath = this._maskCanvasList.reduce((path, maskCanvasData) => {
            if (!maskCanvasData.isSelected) {
                path += maskCanvasData.svgPath + ' ';
            }
            return path;
        }, '');

        const path = new Path2D(svgPath);
        this._borderCtx.clearRect(0, 0, this._borderCanvas.width, this._borderCanvas.height);

        // 保存当前绘图状态
        this._borderCtx.save();
        const lineWidth = 4;
        // 绘制主色虚线
        this._borderCtx.strokeStyle = '#2500ff99';
        this._borderCtx.lineWidth = lineWidth;
        this._borderCtx.setLineDash([12, 8]);
        this._borderCtx.stroke(path);

        // 绘制白色间隔线
        // this._borderCtx.strokeStyle = 'rgba(255, 255, 255, 0.8)';
        // this._borderCtx.lineWidth = lineWidth;
        // this._borderCtx.setLineDash([lineDash, lineDash]);
        // this._borderCtx.lineDashOffset = lineDash; // 偏移白色虚线，使其与黑色虚线错开
        // this._borderCtx.stroke(path);
        // 恢复到之前的绘图状态
        this._borderCtx.restore();
    }
    async _initPointImage() {
        const __loadPointImage = (image, src) => {
            return new Promise((resolve, reject) => {
                image.src = src;
                image.onload = () => {
                    resolve();
                };
                image.onerror = () => {
                    reject();
                };
            });
        };

        this._addPointImage = new Image();
        this._removePointImage = new Image();
        this._isMobile && (this._selectedPointImage = new Image());

        try {
            if (this._isMobile) {
                await __loadPointImage(this._selectedPointImage, FJConfig.selectedPointImage);
            } else {
                await __loadPointImage(this._addPointImage, FJConfig.addPointImage);
                await __loadPointImage(this._removePointImage, FJConfig.removePointImage);
            }
            return true;
        } catch (error) {
            console.error(error);
            return false;
        }
    }

    _drawPointToCanvas(maskCanvasData) {
        const pointSize = this._pointSize;
        const point = {
            x: maskCanvasData.clickPoint.x * this._canvas.width - pointSize / 2,
            y: maskCanvasData.clickPoint.y * this._canvas.height - pointSize / 2,
        };
        if (this._isMobile) {
            // 移动端画勾
            this._pointCtx.drawImage(this._selectedPointImage, point.x, point.y, pointSize, pointSize);
        } else if (maskCanvasData.isHoverIn) {
            this._pointCtx.drawImage(this._removePointImage, point.x, point.y, pointSize, pointSize);
        } else {
            this._pointCtx.drawImage(this._addPointImage, point.x, point.y, pointSize, pointSize);
        }
    }

    /**
     * @desc 更新视图
     */
    updateView(isMove = false, showPoint = true) {
        if (!this._loaded) return;
        this._ctx.clearRect(0, 0, this._canvas.width, this._canvas.height);
        this._hoverInCtx.clearRect(0, 0, this._hoverInCanvas.width, this._hoverInCanvas.height);
        this._pointCtx.clearRect(0, 0, this._pointCanvas.width, this._pointCanvas.height);

        this._maskCanvasList.forEach(maskCanvas => {
            if (maskCanvas.isSelected) {
                this._ctx.drawImage(maskCanvas.canvas, 0, 0, this._canvas.width, this._canvas.height);
                showPoint && this._drawPointToCanvas(maskCanvas);
            }
            if (maskCanvas.isHoverIn && !this._isMobile) {
                if (isMove) {
                    maskCanvas.isHoverIn = false;
                } else {
                    this._hoverInCtx.drawImage(
                        maskCanvas.canvas,
                        0,
                        0,
                        this._hoverInCanvas.width,
                        this._hoverInCanvas.height,
                    );
                }
            }
        });
        this._ctx.save();
        this._ctx.globalCompositeOperation = 'source-in';
        this._ctx.globalAlpha = 0.4;
        this._ctx.drawImage(this._excessiveCanvas, 0, 0, this._canvas.width, this._canvas.height);
        this._ctx.restore();

        this._hoverInCtx.save();
        this._hoverInCtx.globalCompositeOperation = 'source-in';
        this._hoverInCtx.globalAlpha = 0.2;
        this._hoverInCtx.drawImage(this._excessiveCanvas, 0, 0, this._canvas.width, this._canvas.height);
        this._hoverInCtx.restore();

        this._ctx.drawImage(this._hoverInCanvas, 0, 0, this._canvas.width, this._canvas.height);
        this._ctx.drawImage(this._pointCanvas, 0, 0, this._canvas.width, this._canvas.height);
        this._updateMaskBorderCanvas();
    }

    draw(ctx, rect, isDrawBorder = true) {
        if (!this._loaded || !this._active) return;
        isDrawBorder && this._isMobile && ctx.drawImage(this._borderCanvas, rect.x, rect.y, rect.width, rect.height);
        ctx.drawImage(this._canvas, rect.x, rect.y, rect.width, rect.height);
    }

    /**
     * @desc 获取所有可能的maskCanvas
     * @param {number} relativeX
     * @param {number} relativeY
     */
    _getMaskCanvasByPoint(relativeX, relativeY) {
        if (relativeX < 0 || relativeY < 0 || relativeX > 1 || relativeY > 1) return [];
        const maskCanvasList = [];

        const width = this._maskCanvasSize.width;
        const height = this._maskCanvasSize.height;

        const heightPixel = Math.floor(height * relativeY) * width;
        const widthPixel = Math.floor(width * relativeX);

        const maskCanvasIndex = heightPixel + widthPixel;

        const maskCanvasHasSelectData = this._maskCanvasHasSelectData[maskCanvasIndex] || [];

        const isHasSelected = maskCanvasHasSelectData.findIndex(index => this._maskCanvasList[index].isSelected) !== -1;

        maskCanvasHasSelectData.forEach(index => {
            const maskCanvas = this._maskCanvasList[index];
            if (isHasSelected) {
                if (maskCanvas.isSelected) {
                    maskCanvasList.push(maskCanvas);
                }
            } else {
                maskCanvasList.push(maskCanvas);
            }
        });

        return maskCanvasList;
    }

    /**
     * @desc 鼠标移动事件
     * @param {number} relativeX
     * @param {number} relativeY
     */
    mouseMoveHandler(relativeX, relativeY, isMouseInToolPanel) {
        if (!this._loaded) return false;

        // 获取当前 hover 状态下的 maskCanvas
        let currentHoverInMaskCanvas = null;
        this._maskCanvasList.forEach(maskCanvas => {
            if (maskCanvas.isHoverIn) {
                currentHoverInMaskCanvas = maskCanvas;
            }
        });

        if (relativeX < 0 || relativeY < 0 || isMouseInToolPanel) {
            if (currentHoverInMaskCanvas) {
                currentHoverInMaskCanvas.isHoverIn = false;
                this.updateView();
                return true;
            }
            return false;
        }

        // 获取当前点的maskCanvas列表
        const pointInMaskCanvasList = this._getMaskCanvasByPoint(relativeX, relativeY);
        let newHoverInMaskCanvas = pointInMaskCanvasList[0];

        let isUpdateView = false;
        currentHoverInMaskCanvas &&
            currentHoverInMaskCanvas !== newHoverInMaskCanvas &&
            ((currentHoverInMaskCanvas.isHoverIn = false), (isUpdateView = true));

        if (newHoverInMaskCanvas) {
            newHoverInMaskCanvas.isHoverIn = true;
            isUpdateView = true;
        }

        if (isUpdateView) {
            this.updateView();
        }

        return isUpdateView;
    }

    /**
     * @desc 鼠标按下事件
     * @param {number} relativeX
     * @param {number} relativeY
     * @param {function} addUndo 添加撤销
     */
    mouseDownHandler(relativeX, relativeY, addUndo) {
        if (!this._loaded || relativeX < 0 || relativeY < 0) return false;

        const pointInMaskCanvasList = this._getMaskCanvasByPoint(relativeX, relativeY);

        let newSelectedMaskCanvas = pointInMaskCanvasList[0];

        for (let i = 0; i < pointInMaskCanvasList.length; i++) {
            const maskCanvas = pointInMaskCanvasList[i];

            if (maskCanvas.isHoverIn) {
                newSelectedMaskCanvas = maskCanvas;
                break;
            }
        }

        if (newSelectedMaskCanvas) {
            addUndo && addUndo();
            newSelectedMaskCanvas.isSelected = !newSelectedMaskCanvas.isSelected;

            if (newSelectedMaskCanvas.isSelected) {
                newSelectedMaskCanvas.clickPoint = {
                    x: relativeX,
                    y: relativeY,
                };
            }
            this.updateView();
            return true;
        }
        return false;
    }
    /**
     * @desc 鼠标事件
     * @param {number} relativeX
     * @param {number} relativeY
     * @param {function} addUndo 添加撤销
     */
    mouseUpHandler(relativeX, relativeY, addUndo) {
        if (!this._loaded || relativeX < 0 || relativeY < 0) return false;

        const pointInMaskCanvasList = this._getMaskCanvasByPoint(relativeX, relativeY);

        let newSelectedMaskCanvas = pointInMaskCanvasList[0];

        for (let i = 0; i < pointInMaskCanvasList.length; i++) {
            const maskCanvas = pointInMaskCanvasList[i];

            if (maskCanvas.isHoverIn) {
                newSelectedMaskCanvas = maskCanvas;
                break;
            }
        }

        if (newSelectedMaskCanvas) {
            addUndo && addUndo();
            newSelectedMaskCanvas.isSelected = !newSelectedMaskCanvas.isSelected;

            if (newSelectedMaskCanvas.isSelected) {
                newSelectedMaskCanvas.clickPoint = {
                    x: relativeX,
                    y: relativeY,
                };
            }
            this.updateView();
            return true;
        }
        return false;
    }
    mouseLeaveHandler() {
        let updateView = false;
        this._maskCanvasList.forEach(maskCanvas => {
            if (maskCanvas.isHoverIn) {
                maskCanvas.isHoverIn = false;
                updateView = true;
            }
        });
        updateView && this.updateView();
        return updateView;
    }

    /**
     * @desc 清空画布列表
     */
    clearCanvasList() {
        if (!this._maskCanvasList.length) return;

        this._maskCanvasList.forEach(maskCanvas => {
            maskCanvas.canvas?.close();
        });
        this._maskCanvasList = [];
        this._aiMaskId = null;
        this._loaded = false;
    }

    getMaskData() {
        if (!this._loaded || !this._active) return null;
        return this._ctx.getImageData(0, 0, this._canvas.width, this._canvas.height);
    }

    getLoaded() {
        return this._loaded;
    }

    reset() {
        this._maskCanvasList.forEach(maskCanvas => {
            maskCanvas.isHoverIn = false;
            maskCanvas.isSelected = false;
        });
        this.updateView();
    }

    /**
     * @desc 获取 maskCanvas UndoRedo 数据
     */
    getUndoRedoData() {
        let maskCanvasIsSelectedList = [];
        let pointList = [];

        this._maskCanvasList.forEach(maskCanvas => {
            maskCanvasIsSelectedList.push(maskCanvas.isSelected ? 1 : 0);
            pointList.push(maskCanvas.clickPoint ? `${maskCanvas.clickPoint.x},${maskCanvas.clickPoint.y}` : null);
        });

        const data = {
            maskCanvasIsSelectedList: maskCanvasIsSelectedList.join(','),
            pointList: pointList.join('/'),
        };

        return JSON.stringify(data);
    }

    /**
     * @desc 设置 maskCanvas UndoRedo 数据
     * @param {string} undoRedoData
     */
    setUndoRedoData(undoRedoData) {
        if (!undoRedoData) return;
        const data = JSON.parse(undoRedoData);
        const maskCanvasIsSelectedList = data.maskCanvasIsSelectedList.split(',').map(item => item === '1');
        const pointList = data.pointList.split('/').map(item => {
            const [x, y] = item.split(',');

            return { x: parseFloat(x), y: parseFloat(y) };
        });

        this._maskCanvasList.forEach((maskCanvas, index) => {
            maskCanvas.isSelected = maskCanvasIsSelectedList[index];
            maskCanvas.clickPoint = pointList[index];
        });

        this.updateView();
    }

    /**
     * @desc 获取maskCanvas的尺寸
     * @param {number} width
     * @param {number} height
     */
    _getMaskCanvasSize(width, height) {
        const ratio = width / height;
        const maxWidth = Math.min(width, MAX_MASK_CANVAS_WIDTH);
        const maxHeight = Math.min(height, MAX_MASK_CANVAS_HEIGHT);

        return {
            width: Math.floor(Math.min(maxWidth, maxHeight * ratio)),
            height: Math.floor(Math.min(maxHeight, maxWidth / ratio)),
        };
    }

    clear() {
        this.clearCanvasList();
        this.updateView();
    }

    isUse() {
        const maskData = this._ctx.getImageData(0, 0, this._canvas.width, this._canvas.height);

        for (let i = 0; i < maskData.data.length; i += 4) {
            const alpha = maskData.data[i + 3];
            if (alpha > 0) {
                return true;
            }
        }
        return false;
    }

    setActive(value) {
        this._active = value;
    }

    getActive() {
        return this._active;
    }
}

export default FJAiMaskCanvas;
